var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Col',{staticClass:"mt-1 ml-4",attrs:{"cols":"11"}},_vm._l((_vm.lc.propagationInfo),function(line,index){return _c('span',{key:line[index],staticClass:"d-block",domProps:{"textContent":_vm._s(line)}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }